import { render } from "./ReservasiFailed.vue?vue&type=template&id=fc430db0"
import script from "./ReservasiFailed.vue?vue&type=script&lang=js"
export * from "./ReservasiFailed.vue?vue&type=script&lang=js"

import "./ReservasiFailed.vue?vue&type=style&index=0&id=fc430db0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__